import { z } from "zod"

export const IngestProtocol = z.union([z.literal("rtmp"), z.literal("srt"), z.literal("webrtc")])

export type IngestProtocol = z.infer<typeof IngestProtocol>
